import React from 'react';
import '../Cards.css';
import CardItem from '../CardItem';

function Dyslexia() {
  window.scrollTo(0, 0)
  return (
    <div>
      <div id='about' className='cards'>
        <h1>decodeLabs</h1>
        <h3 className="cards-description">Developed a full-stack website to combat dyslexia in partnership with Genesis School for Special Education. We were shocked by the lack of science-backed, long-term progress tracking dyslexia solutions that could actually make significant improvements to the lives of dyslexics. We gamified the Orton-Gillingham method of teaching sequencing in order to make it appeal to young students. We also launched a programming class when we realised how interested the students were in the work we were doing.
          <br></br>
          <br></br>
          <a style={{ textDecoration: "none;", color: "green", hover: "red" }} target="_blank" href="https://contactdecodelabs.wixsite.com/decodelabs">decodeLabs website</a>
          <br></br>
          <br></br>
          <a style={{ textDecoration: "none;", color: "green", hover: "red" }} target="_blank" href="https://dyslexia-d9e5d.firebaseapp.com/">decodeLabs learning platform</a>

        </h3>

        <div className='cards__container'>
          <div className='cards__wrapper'>
            <ul className='cards__items'>

              <CardItem
                src='images/decodelabs2.png'
                text='Level select'
                label="Screenshot"
                path='/GrowLah'
              />

              <CardItem
                src='images/decodelabs3.png'
                text='Progress tracking'
                label='Screenshot'
                path='/dyslexia'
              />

            </ul>
            <ul className='cards__items'>

              <CardItem
                src='images/decodelabs1.png'
                text='Level preview (picture only)'
                label="Screenshot"
                path='/GrowLah'
              />

              <CardItem
                src='images/decodelabs4.png'
                text='Tutorial section'
                label='Screenshot'
                path='/dyslexia'
              />

              <CardItem
                src='images/decodelabs5.png'
                text='Level preview (audio only)'
                label='Screenshot'
                path='/dyslexia'
              />

            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Dyslexia
